'use strict';
module.exports = !!(typeof window !== 'undefined' && window.document && window.document.createElement);


//////////////////
// WEBPACK FOOTER
// ./~/react-bootstrap/~/dom-helpers/util/inDOM.js
// module id = 66
// module chunks = 0